import styled from 'shared/utils/styled';

export const Label = styled('span')(({ theme }) => ({
  minHeight: 20,
  fontFamily: 'NeoSansStd',
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 600,
  lineHeight: '20px',
  color: '#224060',
}));

export const Sup = styled('sup')(() => ({
  lineHeight: 1,
}));
